import React from "react";
import PropTypes from "prop-types";
import SbEditable from "storyblok-react";
import { BLOK_ARRAY } from "../../../prop_types";
import DescriptionList from "./description_list";
import * as classes from "./description_list_item.module.scss";

export default function DescriptionListItem({
  description,
  descriptionTitle,
  subList,
  ...rest
}) {
  return (
    <>
      <SbEditable content={rest}>
        <dt className={classes.descriptionTitle}>{descriptionTitle}</dt>
      </SbEditable>
      <SbEditable content={rest}>
        <dd className={classes.description}>{description}</dd>
      </SbEditable>
      {subList?.length > 0 &&
        subList.map((item) => {
          return (
            <div className={classes.subList} key={item._uid}>
              <DescriptionList {...item} />
            </div>
          );
        })}
    </>
  );
}

DescriptionListItem.defaultProps = {
  description: null,
  descriptionTitle: null,
  subList: null,
};

DescriptionListItem.propTypes = {
  description: PropTypes.string,
  descriptionTitle: PropTypes.string,
  subList: BLOK_ARRAY,
};
